import React from 'react';

import { Divider } from '@mui/material';

import { useGetGeneralStats, useGetIncidenceStats } from '../../api';
import { useGetSidebarMenuAreas } from './SidebarMenu.consts';
import { StyledDivider, StyledMenuOption, StyledWrapper } from './SidebarMenu.styles';
import { SidebarMenuList } from './SidebarMenuList';

export const SidebarMenu = () => {
    const { generalStats, isLoading: isLoadingGeneralStats } = useGetGeneralStats();
    const { incidenceStats, isLoading: isLoadingIncidenceStats } = useGetIncidenceStats();

    const sidebarMenuAreas = useGetSidebarMenuAreas({
        ...generalStats,
        incidences: incidenceStats?.total,
    });

    const isLoadingStats = isLoadingGeneralStats || isLoadingIncidenceStats;

    return (
        <StyledWrapper className="abono-sidebar-menu">
            {sidebarMenuAreas.map((items, index) => (
                <React.Fragment key={`${index}`}>
                    <StyledMenuOption>
                        <SidebarMenuList items={items} isStatisticsLoading={isLoadingStats} />
                    </StyledMenuOption>
                    <StyledDivider>
                        <Divider sx={{ bgcolor: 'components.divider' }} />
                    </StyledDivider>
                </React.Fragment>
            ))}
        </StyledWrapper>
    );
};
